"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBar = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
const TextV2_1 = require("../../foundations/Typography/TextV2");
const ProgressBar = ({ value, showLabel = true }) => {
    // ensure the value is between 0 and 100
    const clampedValue = Math.max(0, Math.min(100, value));
    return (react_1.default.createElement(foundations_1.Box, { sx: {
            display: "flex",
            alignItems: "center",
            height: "1.5em" // matches lineHeight of text
        } },
        react_1.default.createElement(foundations_1.Box, { role: "progressbar", "aria-label": `Progress bar at ${clampedValue}%`, "aria-valuenow": clampedValue, "aria-valuemin": 0, "aria-valuemax": 100, sx: {
                flexGrow: 1,
                borderRadius: "radius-1",
                background: "surface-neutral-tertiary"
            } },
            react_1.default.createElement(foundations_1.Box, { sx: {
                    height: "spacing-3",
                    width: `${clampedValue}%`,
                    borderRadius: "radius-1",
                    background: "button-surface-filled-enabled"
                } })),
        showLabel && (react_1.default.createElement(TextV2_1.TextV2, { variant: "body-2-regular", sx: { ml: "spacing-4" } },
            Math.round(clampedValue),
            "%"))));
};
exports.ProgressBar = ProgressBar;
//# sourceMappingURL=ProgressBar.js.map